var _path, _path2, _path3, _path4, _g;

var _excluded = ["title", "titleId"];

function _extends() { _extends = Object.assign ? Object.assign.bind() : function (target) { for (var i = 1; i < arguments.length; i++) { var source = arguments[i]; for (var key in source) { if (Object.prototype.hasOwnProperty.call(source, key)) { target[key] = source[key]; } } } return target; }; return _extends.apply(this, arguments); }

function _objectWithoutProperties(source, excluded) { if (source == null) return {}; var target = _objectWithoutPropertiesLoose(source, excluded); var key, i; if (Object.getOwnPropertySymbols) { var sourceSymbolKeys = Object.getOwnPropertySymbols(source); for (i = 0; i < sourceSymbolKeys.length; i++) { key = sourceSymbolKeys[i]; if (excluded.indexOf(key) >= 0) continue; if (!Object.prototype.propertyIsEnumerable.call(source, key)) continue; target[key] = source[key]; } } return target; }

function _objectWithoutPropertiesLoose(source, excluded) { if (source == null) return {}; var target = {}; var sourceKeys = Object.keys(source); var key, i; for (i = 0; i < sourceKeys.length; i++) { key = sourceKeys[i]; if (excluded.indexOf(key) >= 0) continue; target[key] = source[key]; } return target; }

import * as React from "react";

function SvgCodeshipIcon(_ref, svgRef) {
  var title = _ref.title,
      titleId = _ref.titleId,
      props = _objectWithoutProperties(_ref, _excluded);

  return /*#__PURE__*/React.createElement("svg", _extends({
    xmlns: "http://www.w3.org/2000/svg",
    viewBox: "-13.687 -3.28 66.521 66.527",
    height: 64,
    width: 64,
    ref: svgRef,
    "aria-labelledby": titleId
  }, props), title ? /*#__PURE__*/React.createElement("title", {
    id: titleId
  }, title) : null, _path || (_path = /*#__PURE__*/React.createElement("path", {
    d: "M19.575.094c-16.48 0-29.9 13.4-29.9 29.9s13.4 29.9 29.9 29.9 29.9-13.4 29.9-29.9-13.41-29.9-29.9-29.9zm0 63.153c-18.342 0-33.264-14.92-33.264-33.263S1.233-3.28 19.575-3.28s33.262 14.922 33.262 33.264-14.92 33.263-33.262 33.263",
    fill: "#323e4e"
  })), _path2 || (_path2 = /*#__PURE__*/React.createElement("path", {
    d: "M14.38 11.355V5.97c0-.776 3.053-1.642 5.125-1.642s5.234.866 5.234 1.642v5.373c-1.748-.33-3.615-.56-5.184-.56-1.586 0-3.448.235-5.174.57",
    fill: "#5e6372"
  })), _path3 || (_path3 = /*#__PURE__*/React.createElement("path", {
    d: "M12.186 44.16c-4.57 0-8.296-1.416-9.683-1.56-2.062-.213-4.25-2.233-6.233-2.233-.33 0-.654.056-.97.185a26.59 26.59 0 0 1-1.134-3.206C-2.6 34.4.5 33.42 3.133 33.42c5.03 0 8.485 3.513 8.5 3.563.27.25 5.228 3.913 7.9 4.506l2.03.258c-3.208 1.842-6.458 2.416-9.368 2.416",
    fill: "#666a79"
  })), _path4 || (_path4 = /*#__PURE__*/React.createElement("path", {
    d: "M-4.652 40.675l.005-.002-.045-.1z",
    fill: "#b42c9d"
  })), _g || (_g = /*#__PURE__*/React.createElement("g", {
    fill: "#323e4e"
  }, /*#__PURE__*/React.createElement("path", {
    d: "M30.618 21.432v-5.616c0-.776-6.687-2.56-11.064-2.56s-10.83 1.785-10.83 2.56v5.546c5.123-3.663 10.74-5.295 10.74-5.295.017-.004 6 1.644 11.154 5.365M33.315 32.5c-1.657.317-3.598 2.697-6.1 5.103 1-3.546 2.8-7.523 6.05-10.95-.878-.796-1.773-1.52-2.662-2.18v-.015c-3.275-2.417-7.064-4.492-10.994-5.632l-.004.001c-1.624.424-3.225 1.184-4.732 1.9-3.246 1.544-6.3 3.5-8.965 5.92l-.005.004c2.904 2.945 4.634 6.646 5.67 10.103l.072.228c.27.25.55.5.828.738 2.04 1.737 4.35 3.168 7 3.762l-.01-.082-1.045-8.454-.266-5.7 1.43-6.514 1.3 6.514-.312 5.705-.943 8.554 1.916.23c-3.103 1.428-7.947 2.204-12.97-.2-2.028-.97-4-1.893-6.26-2.128-2.404-.25-4.798.23-7.023 1.136h-.01v.02l.045.1C-.35 50.45 9.702 56.83 20.386 56.503c10.476-.32 20-7.07 23.816-16.827a25.41 25.41 0 0 0 .57-1.61c-3.605-2.654-9.27-5.988-11.458-5.568"
  }), /*#__PURE__*/React.createElement("path", {
    d: "M33.315 32.5c2.2-.42-1.657.317 0 0"
  }))));
}

var ForwardRef = /*#__PURE__*/React.forwardRef(SvgCodeshipIcon);
export default __webpack_public_path__ + "static/media/codeship-icon.72a6608842fc0dd214c9534b7f93640f.svg";
export { ForwardRef as ReactComponent };